import { render, staticRenderFns } from "./svg-trash.vue?vue&type=template&id=8c5f9e14&"
import script from "./svg-trash.vue?vue&type=script&lang=js&"
export * from "./svg-trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports